// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Utils
import { refreshPushNotificationsSubscription } from '../../../../../notifications/push/pushNotificationsManager';
import logger from '../../../../../logger/logger';
import {
    getHasPushBeenSuggested,
    setPushHasBeenPermanentlyDismissed,
    setPushHasBeenSuggested,
} from './pushSuggestionService';

// Components
import SuggestionPopupContent from '../../../../../components/popupPanel/SuggestionPopupContent';
import ModalCloseButton from '../../../../../components/modal/ModalCloseButton';
import LinkButton from '../../../../../components/buttons/LinkButton';
import StyledButton from '../../../../../components/buttons/StyledButton';

// Constants
import { NOTIFICATION_PERMISSIONS } from '../../../../../notifications/push/pushNotificationsConstants';

// Styles
import './PushNotificationsSuggestionPopup.scss';

class PushNotificationsSuggestionPopup extends React.Component {
    componentDidMount() {
        // If the popup is closed by clicking outside of the popup then the next time
        // we show the popup it should show the options
        setPushHasBeenSuggested();
    }

    onDismiss = () => {
        this.props.onClose();
        setPushHasBeenSuggested();
    };

    onPermanentDismiss = () => {
        this.props.onClose();
        setPushHasBeenPermanentlyDismissed();
    };

    requestPushNotificationPermission = () => {
        const { onClose } = this.props;

        onClose();

        refreshPushNotificationsSubscription().catch((err) => {
            // The user denied permission to notifications
            if (err === NOTIFICATION_PERMISSIONS.default || err === NOTIFICATION_PERMISSIONS.denied) return;

            logger.error('Unable to subscribe to notifications', err, JSON.stringify(err, null, 2));
            alert('An error occurred trying to subscribe'); // eslint-disable-line no-alert
        });
    };

    render() {
        const showDismissActions = getHasPushBeenSuggested();

        return (
            <SuggestionPopupContent>
                <ModalCloseButton close={this.onDismiss} />
                <div className="body">
                    <h3 className="message">Milanote needs your permission to enable desktop notifications</h3>
                    <StyledButton className="primary thin" onClick={this.requestPushNotificationPermission}>
                        Enable desktop notifications
                    </StyledButton>
                    {showDismissActions && (
                        <div className="dismiss-actions">
                            <LinkButton className="secondary-action" onClick={this.onDismiss}>
                                Not now
                            </LinkButton>
                            <LinkButton className="secondary-action" onClick={this.onPermanentDismiss}>
                                Don&apos;t ask again
                            </LinkButton>
                        </div>
                    )}
                </div>
                <div className="push-illustration-container">
                    <img className="push-bell" src={require('./push-bell-warning.png')} />
                </div>
            </SuggestionPopupContent>
        );
    }
}

PushNotificationsSuggestionPopup.propTypes = {
    onClose: PropTypes.func,
    dispatchPushSuggestionPopupShown: PropTypes.func,
};

export default PushNotificationsSuggestionPopup;
